import { render } from "./FormularioValidacao.vue?vue&type=template&id=aae1d8b8"
import script from "./FormularioValidacao.vue?vue&type=script&lang=js"
export * from "./FormularioValidacao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__